import { homeData } from "@/mocks/homeData";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import AdvantagesSection from "./components/AdvantagesSection";
import ScenariosSection from "./components/ScenariosSection";
import ReviewsSection from "./components/ReviewsSection";
import BuyingGuideSection from "./components/BuyingGuideSection";
import FAQSection from "./components/FAQSection";
import SEOHead from "@/components/base/SEOHead";

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "爱威奶官网",
  "url": "https://www.aiweinai.com/",
  "description": "爱威奶是备受关注的热门产品，本页为您全面介绍爱威奶的核心优势、使用场景、用户口碑及购买指南。",
  "inLanguage": "zh-CN",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://www.aiweinai.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "爱威奶",
  "url": "https://www.aiweinai.com/",
  "description": "爱威奶 - 呵护每一刻，品质新选择",
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "400-888-9999",
    "contactType": "customer service",
    "availableLanguage": "Chinese",
  },
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "爱威奶适合哪些人群使用？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "爱威奶适合全年龄段人群，包括儿童、青少年、成年人及中老年人。特别针对不同年龄段推出了针对性的营养配方，满足各阶段人群的不同营养需求。",
      },
    },
    {
      "@type": "Question",
      "name": "爱威奶的保质期是多久？如何储存？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "爱威奶未开封状态下保质期为12个月。建议存放于阴凉干燥处，避免阳光直射。开封后请密封保存并于30天内饮用完毕。",
      },
    },
    {
      "@type": "Question",
      "name": "爱威奶的使用方法是什么？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "建议每日饮用200-300ml，可直接饮用或温热后饮用。可搭配早餐、作为餐后饮品或运动后补充。",
      },
    },
    {
      "@type": "Question",
      "name": "爱威奶与其他同类产品相比有什么优势？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "爱威奶采用科学配方和天然原料，不添加人工色素和防腐剂。经过严格品控，拥有多项国家质量认证和完善的冷链物流体系。",
      },
    },
    {
      "@type": "Question",
      "name": "爱威奶在哪里可以购买？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "爱威奶可通过官方网站在线订购，也可在全国各大商超、母婴店和药店购买。",
      },
    },
    {
      "@type": "Question",
      "name": "爱威奶是否适合乳糖不耐受人群？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "爱威奶特别推出了低乳糖配方系列，适合乳糖不耐受人群饮用。特殊体质建议在饮用前咨询医生。",
      },
    },
    {
      "@type": "Question",
      "name": "爱威奶的配送范围和时效是怎样的？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "爱威奶目前已覆盖全国主要城市，一二线城市通常下单后24-48小时内送达，其他地区3-5个工作日送达。全程冷链物流。",
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="爱威奶官网 - 爱威奶全攻略，核心优势、使用方法、用户口碑一站式了解"
        description="爱威奶是备受关注的热门产品，本页为您全面介绍爱威奶的核心优势、使用场景、用户口碑及购买指南，助您快速了解爱威奶，做出最优选择。爱威奶官网为您提供价格、使用方法、评测等全方位信息。"
        keywords="爱威奶,爱威奶官网,爱威奶价格,爱威奶使用方法,爱威奶评测,爱威奶购买,爱威奶用户口碑"
        canonicalUrl="https://www.aiweinai.com/"
        ogTitle="爱威奶官网 - 爱威奶全攻略，核心优势、使用方法、用户口碑一站式了解"
        ogDescription="爱威奶是备受关注的热门产品，本页为您全面介绍爱威奶的核心优势、使用场景、用户口碑及购买指南。"
        ogUrl="https://www.aiweinai.com/"
        schemaJson={{ ...homeSchema, ...orgSchema, ...faqSchema }}
      />

      <Navbar />
      <main>
        <HeroSection
          title={homeData.hero.title}
          subtitle={homeData.hero.subtitle}
          description={homeData.hero.description}
          cta={homeData.hero.cta}
          ctaSecondary={homeData.hero.ctaSecondary}
        />
        <AdvantagesSection
          sectionTitle={homeData.advantages.sectionTitle}
          sectionSubtitle={homeData.advantages.sectionSubtitle}
          items={homeData.advantages.items}
        />
        <ScenariosSection
          sectionTitle={homeData.scenarios.sectionTitle}
          sectionSubtitle={homeData.scenarios.sectionSubtitle}
          items={homeData.scenarios.items}
        />
        <ReviewsSection
          sectionTitle={homeData.reviews.sectionTitle}
          sectionSubtitle={homeData.reviews.sectionSubtitle}
          items={homeData.reviews.items}
        />
        <BuyingGuideSection
          sectionTitle={homeData.buyingGuide.sectionTitle}
          sectionSubtitle={homeData.buyingGuide.sectionSubtitle}
          steps={homeData.buyingGuide.steps}
        />
        <FAQSection
          sectionTitle={homeData.faq.sectionTitle}
          sectionSubtitle={homeData.faq.sectionSubtitle}
          items={homeData.faq.items}
        />
      </main>
      <Footer />
    </>
  );
}